export default __webpack_public_path__ + "static/media/logo-uidb.cd6c476c.png";